import { UserManagementActions } from './UserManagementActions';

export class UserManagementEvents {
  category = 'User Management';
  action = new UserManagementActions();
}

